import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

import { buildDataLayer, GTM_ID } from './constants';

type UseGTMParams = { pharmacyId?: string | null };

export const useGTM = ({ pharmacyId }: UseGTMParams): void => {
  useEffect(() => {
    if (!pharmacyId) {
      return;
    }

    TagManager.initialize({
      gtmId: GTM_ID,
      dataLayer: buildDataLayer(pharmacyId),
    });
  }, [pharmacyId]);
};
